import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'

import { ns1 as deNs1 } from './de/ns1'
import { ns1 } from './en/ns1'

// add more namespaces here
export const namespaces = ['ns1'] as const
export type Namespace = (typeof namespaces)[number]

// add more languages here
export const languages = ['en', 'de'] as const
export type Language = (typeof languages)[number]

export const resources = {
  en: { ns1 },
  de: { ns1: deNs1 },
} satisfies Partial<Record<Language, Record<Namespace, unknown>>>

export const defaultNS: Namespace = 'ns1'

// The active language is resolved from the server (whoAmI.preferences) during
// the app bootstrap; init in English and let the bootstrap switch before the
// first content paint.
void i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    defaultNS,
    resources,
    lng: 'en',
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  })

document.documentElement.lang = i18n.language

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language
})
